import { render } from "./TrailerLookup.vue?vue&type=template&id=3ccd6f6b&scoped=true&ts=true"
import script from "./TrailerLookup.vue?vue&type=script&lang=ts"
export * from "./TrailerLookup.vue?vue&type=script&lang=ts"

import "./TrailerLookup.vue?vue&type=style&index=0&id=3ccd6f6b&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccd6f6b"]])

export default __exports__